/* Arkodd — click-to-zoom for reference diagrams in page content. */
(() => {
  const SELECTOR = '.rte img';
  let overlay = null;

  const close = () => {
    if (!overlay) return;
    overlay.removeAttribute('data-open');
    const node = overlay;
    overlay = null;
    setTimeout(() => node.remove(), 200);
    document.documentElement.style.overflow = '';
  };

  const open = (src, alt) => {
    close();
    overlay = document.createElement('dialog');
    overlay.className = 'zoom-overlay';
    overlay.innerHTML =
      '<img alt=""><p class="zoom-overlay__hint">Click outside the image or press Esc to close</p>';
    const img = overlay.querySelector('img');
    img.src = src;
    img.alt = alt || '';
    document.body.appendChild(overlay);
    overlay.showModal();
    document.documentElement.style.overflow = 'hidden';
    // rAF alone is unreliable (throttled in background tabs) — belt and braces
    const reveal = () => overlay && overlay.setAttribute('data-open', '');
    requestAnimationFrame(reveal);
    setTimeout(reveal, 60);
    // Close on the backdrop or the hint — never on the image itself, so the
    // pointer sequence that opened the overlay can't immediately dismiss it.
    overlay.addEventListener('click', (event) => {
      if (event.target === img) return;
      close();
    });
    overlay.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  };

  document.addEventListener('click', (event) => {
    const img = event.target.closest(SELECTOR);
    // let real links (e.g. an image wrapped in an <a>) do their job
    if (!img || img.closest('a')) return;
    event.preventDefault();
    open(img.currentSrc || img.src, img.alt);
  });
})();
